import Grid from "@mui/material/Unstable_Grid2";
import InfoIcon from "@mui/icons-material/Info";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { Button } from "@mui/material";
import Select from "react-select";
import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SyncIcon from "@mui/icons-material/Sync";
import SaveIcon from "@mui/icons-material/Save";
import ImagesearchRollerIcon from "@mui/icons-material/ImagesearchRoller";
import { IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
const Transactions = () => {
  const [tableData, settableData] = useState([
    {
      type: "Fee",
      reason: "Franchise",
      amount: "625000.00",
      currency: "Indian Rupee",
      paymentDate: "14-Feb-2019",
      comment: "",
      user: "chaffin_d",
      date: "05-Mar-2019 14:09:25",
    },
    {
      type: "Fee",
      reason: "Tax",
      amount: "75000.00",
      currency: "Indian Rupee",
      paymentDate: "14-Feb-2019",
      comment: "12 % GST",
      user: "chaffin_d",
      date: "05-Mar-2019 14:10:02",
    },
  ]);
  const displayContainer = {
    display: "flex",
    gap: 20,
    alignItems: "center",
  };
  return (
    <div className="mainFranchiseDetails">
      <Grid container spacing={1}>
        <Grid xs={12}>
          <div className="title">Criteria</div>
        </Grid>

        <Grid xs={8}>
          <div style={displayContainer}>
            <TextField label="Store" />
            <Select placeholder="Satellite" classNamePrefix="custom_select" />
            <IconButton>
              <InfoIcon color="primary" size="large" fontSize="60" />
            </IconButton>
            <Select placeholder="Sequence" classNamePrefix="custom_select" />
            <IconButton>
              <InfoIcon color="primary" size="large" fontSize="60" />
            </IconButton>

            <IconButton>
              <ArrowCircleRightIcon
                color="primary"
                size="large"
                fontSize="60"
              />
            </IconButton>

            <IconButton>
              <ImagesearchRollerIcon
                className="rotate-roller"
                color="primary"
                size="large"
                fontSize="60"
              />
            </IconButton>
          </div>
        </Grid>
        <Grid xs={3}>
          <div className="d-flex flex-end">
            <Button
              size="small"
              className="franchise-agreement-DetailButton"
              startIcon={<SyncIcon />}
            >
              Reset
            </Button>
            <Button
              size="small"
              className="franchise-agreement-DetailButton"
              startIcon={<SaveIcon />}
            >
              Save
            </Button>
          </div>
        </Grid>

        <Grid xs={12} container spacing={1}>
          <Grid xs={12}>
            <div className="title">2 Transaction(s)</div>
          </Grid>
        </Grid>

        <div style={{ width: "100%" }} className="table-con">
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: "#008a52", color: "white" }}>
                <TableRow>
                  <TableCell className="table-cell">Type</TableCell>
                  <TableCell className="table-cell">Reason</TableCell>
                  <TableCell className="table-cell">Amount</TableCell>
                  <TableCell className="table-cell">Currency</TableCell>
                  <TableCell className="table-cell">Payment Date</TableCell>
                  <TableCell className="table-cell">Comment</TableCell>
                  <TableCell className="table-cell">User</TableCell>
                  <TableCell className="table-cell">Date/Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((ele, index) => (
                  <TableRow key={index}>
                    <TableCell>{ele.type}</TableCell>
                    <TableCell>{ele.reason}</TableCell>
                    <TableCell>{ele.amount}</TableCell>
                    <TableCell>{ele.currency}</TableCell>
                    <TableCell>{ele.paymentDate}</TableCell>
                    <TableCell>{ele.comment}</TableCell>
                    <TableCell>{ele.user}</TableCell>
                    <TableCell>{ele.date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </div>
  );
};
export default Transactions;
